__turbopack_context__.v({
  "body": "styles-module-scss-module__TZXL6q__body",
  "button": "styles-module-scss-module__TZXL6q__button",
  "button-wrapper": "styles-module-scss-module__TZXL6q__button-wrapper",
  "close": "styles-module-scss-module__TZXL6q__close",
  "close-icon": "styles-module-scss-module__TZXL6q__close-icon",
  "content": "styles-module-scss-module__TZXL6q__content",
  "logo": "styles-module-scss-module__TZXL6q__logo",
  "root": "styles-module-scss-module__TZXL6q__root",
  "slide": "styles-module-scss-module__TZXL6q__slide",
  "text": "styles-module-scss-module__TZXL6q__text",
  "with-button": "styles-module-scss-module__TZXL6q__with-button",
  "wrapSvg": "styles-module-scss-module__TZXL6q__wrapSvg",
});
